// This dictionary contains 61 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.
import { surveyLocalization } from "survey-core";
/**
 * You don't need to translate strings that have the same value as Portuguese translation
 */
export var portugueseBrSurveyStrings = {
  // pagePrevText: "Previous",
  // pageNextText: "Next",
  // completeText: "Complete",
  // previewText: "Preview",
  // editText: "Edit",
  // startSurveyText: "Start",
  // otherItemText: "Other (describe)",
  // noneItemText: "None",
  // selectAllItemText: "Select All",
  // progressText: "Page {0} of {1}",
  // indexText: "{0} of {1}",
  // panelDynamicProgressText: "{0} of {1}",
  // questionsProgressText: "Answered {0}/{1} questions",
  emptySurvey: "Não há página visível ou pergunta na pesquisa.",
  completingSurvey: "Obrigado por finalizar a pesquisa!",
  completingSurveyBefore: "Nossos registros mostram que você já finalizou a pesquisa.",
  loadingSurvey: "A pesquisa está carregando...",
  // placeholder: "Select...",
  // ratingOptionsCaption: "Select...",
  // value: "value",
  requiredError: "Por favor, responda a pergunta.",
  requiredErrorInPanel: "Por favor, responda pelo menos uma pergunta.",
  requiredInAllRowsError: "Por favor, responda as perguntas em todas as linhas.",
  // numericError: "The value should be numeric.",
  // minError: "The value should not be less than {0}",
  // maxError: "The value should not be greater than {0}",
  // textMinLength: "Please enter at least {0} character(s).",
  // textMaxLength: "Please enter no more than {0} character(s).",
  // textMinMaxLength: "Please enter at least {0} and no more than {1} characters.",
  // minRowCountError: "Please fill in at least {0} row(s).",
  // minSelectError: "Please select at least {0} variant(s).",
  maxSelectError: "Por favor, selecione não mais do que {0} opções.",
  // numericMinMax: "The '{0}' should be at least {1} and at most {2}",
  // numericMin: "The '{0}' should be at least {1}",
  // numericMax: "The '{0}' should be at most {1}",
  invalidEmail: "Por favor, informe um e-mail válido.",
  // invalidExpression: "The expression: {0} should return 'true'.",
  urlRequestError: "A requisição retornou o erro '{0}'. {1}",
  urlGetChoicesError: "A requisição não retornou dados ou o 'caminho' da requisição não está correto",
  // exceedMaxSize: "The file size should not exceed {0}.",
  otherRequiredError: "Por favor, informe o outro valor.",
  uploadingFile: "Seu arquivo está sendo carregado. Por favor, aguarde alguns segundos e tente novamente.",
  loadingFile: "Carregando...",
  // chooseFile: "Choose file(s)...",
  noFileChosen: "Nenhum arquivo escolhido",
  // fileDragAreaPlaceholder: "Drop a file here or click the button below to load the file.",
  confirmDelete: "Tem certeza que deseja deletar?",
  keyDuplicationError: "Esse valor deve ser único.",
  // addColumn: "Add Column",
  // addRow: "Add Row",
  // removeRow: "Remove",
  // emptyRowsText: "There are no rows.",
  // addPanel: "Add new",
  // removePanel: "Remove",
  // choices_Item: "item",
  // matrix_column: "Column",
  // matrix_row: "Row",
  // multipletext_itemname: "text",
  savingData: "Os resultados esto sendo salvos no servidor...",
  savingDataError: "Ocorreu um erro e não foi possível salvar os resultados.",
  savingDataSuccess: "Os resultados foram salvos com sucesso!",
  // saveAgainButton: "Try again",
  // timerMin: "min",
  // timerSec: "sec",
  // timerSpentAll: "You have spent {0} on this page and {1} in total.",
  // timerSpentPage: "You have spent {0} on this page.",
  // timerSpentSurvey: "You have spent {0} in total.",
  // timerLimitAll: "You have spent {0} of {1} on this page and {2} of {3} in total.",
  // timerLimitPage: "You have spent {0} of {1} on this page.",
  // timerLimitSurvey: "You have spent {0} of {1} in total.",
  // clearCaption: "Clear",
  // signaturePlaceHolder: "Sign here",
  chooseFileCaption: "Escolher arquivo",
  removeFileCaption: "Remover este arquivo",
  // booleanCheckedLabel: "Yes",
  // booleanUncheckedLabel: "No",
  confirmRemoveFile: "Tem certeza que deseja remover este arquivo: {0}?",
  confirmRemoveAllFiles: "Tem certeza que deseja remover todos os arquivos?",
  // questionTitlePatternText: "Question Title",
  // modalCancelButtonText: "Cancel",
  // modalApplyButtonText: "Apply",
  // filterStringPlaceholder: "Type to search...",
  // emptyMessage: "No data to display",
  // noEntriesText: "There are no entries yet.\nClick the button below to add a new entry.",
  // more: "More"
};

surveyLocalization.locales["pt-br"] = portugueseBrSurveyStrings;
surveyLocalization.localeNames["pt-br"] = "português brasileiro";
